export interface KngDataTable {
  headers: HeaderDataTable[];
  checkboxRequired: boolean;
  checkboxState: boolean;
  paginationRequired: boolean;
  headerCheckboxdisabled?: boolean;
  mobileSelectAllDisable: boolean;
  tableData: TableData[];
  deleteRowdRequired?: boolean;
}
export interface HeaderDataTable {
  key: string;
  label: string;
  sort: boolean;
  isTooltipPresent? : boolean;
  tooltip?: {
    content: string;
  };
}
export interface TableData {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export interface CheckboxData {
  itemIndex: number; 
  checked: boolean;
  itemData: TableData;
}

export interface NoResultData {
    icon: Image;
    messageBold: string;
    message: string;
}

export interface Image {
  iconPath: string;
  altText: string;
}

export enum Icons {
  noResult = '/assets/noresults.svg'
}
